import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  #app {
    min-height: 100%;
    min-width: 100%;
  }

  .x-hellosign-embedded--in-modal {
    z-index: 999;
  }

  .cameratag_room {
    height: 600px;
  }

  #request-revision-tooltip {
    z-index: 0;
  }

  body #x-gist-floating-bottom-right,
  body #x-gist-floating-bottom {
    z-index: 80;
  }
`;

export default GlobalStyle;
